/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */

// This is to workaround requiring editor-common in this repository which
// makes the dependency tree significantly more complex since editor-common
// needs to be a singleton
export var isGapCursorSelection = function isGapCursorSelection(selection) {
  // @ts-expect-error
  return Boolean(selection.jsonID === 'gapcursor');
};